export function renderFormDatabaseImportsTemplate({
  imports,
  tableName,
  toPascalCase,
  fieldDefs,
  customFieldsCol
}: {
  imports: string
  tableName: string
  toPascalCase: string
  fieldDefs: string
  customFieldsCol: string
}): string {
  return `import { sql } from 'drizzle-orm'
import {
  ${imports}
} from 'drizzle-orm/pg-core'

export const ${tableName} = pgTable('${toPascalCase}Submissions', {
  id: uuid().defaultRandom().primaryKey().notNull(),
${fieldDefs}${customFieldsCol}
  ipAddress: text(),
  userAgent: text(),
  submittedAt: timestamp({ precision: 3, mode: 'string' }).default(sql\`CURRENT_TIMESTAMP\`).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'string' }).default(sql\`CURRENT_TIMESTAMP\`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'string' }).default(sql\`CURRENT_TIMESTAMP\`).notNull()
})
`
}
